import logo from "../assets/recall-rush-logo.png";
import { useEffect } from "react";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full">
      <div className="max-w-2xl mx-auto mt-10 px-4">
        <img src={logo} alt="image" className="w-16 h-16 rounded-lg" />
        <h1 className="mt-4 text-4xl text-[#af61dd] font-bold">
          Terms and Conditions
        </h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2024-12-05
        </p>

        <div className="details mt-4">
          <p>
            Welcome to <span className="font-bold">Recall Rush!</span> These
            Terms and Conditions ("Terms") govern your access to and use of our
            mobile application ("App"), specifically designed for children. By
            downloading, installing, or using the App, you agree to comply with
            and be bound by these Terms.
          </p>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Acceptance of Terms</h1>
            <p className="mt-1">
              By using Recall Rush, you confirm that you have read, understood,
              and agree to these Terms and Conditions, as well as our Privacy
              Policy and Security Policy. These Terms govern the use of the App,
              including all its associated features and services, and are
              designed to ensure a safe, kid-friendly experience.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Use of the App</h1>
            <h3 className="text-xl font-bold mt-2">License</h3>
            <p className="mt-1">
              We grant you a non-exclusive, non-transferable, revocable license
              to use Recall Rush for personal, non-commercial purposes, in
              compliance with these Terms and applicable laws.
            </p>
            <h3 className="text-xl font-bold mt-2">Restrictions</h3>
            <ul className="list-disc ml-5 mt-1">
              <li>
                Modify, copy, distribute, transmit, display, perform, reproduce,
                publish, license, create derivative works from, transfer, or
                sell any content obtained from the App.
              </li>
              <li>
                Use the App for any unlawful or inappropriate purposes, or for
                any purpose prohibited by these Terms.
              </li>
              <li>
                Attempt to gain unauthorized access to the App, other user
                accounts, or computer systems related to the App.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Features of the App</h1>
            <h3 className="text-xl font-bold mt-2">Game Modes</h3>
            <p>The App offers several game modes, designed for kids:</p>
            <ul className="list-disc ml-5 mt-1">
              <li>
                Quick Game Mode: Choose from three difficulty levels: Easy,
                Medium, and Hard.
              </li>
              <li>
                Stage Mode: Over 30 levels for players to complete, with
                increasing difficulty.
              </li>
              <li>
                2 Players Mode (Coming Soon): Play with a friend or another
                user.
              </li>
              <li>
                Shop (Coming Soon): In-app purchases for premium levels and
                features.
              </li>
            </ul>
            <h3 className="text-xl font-bold mt-2">Updates and Changes</h3>
            <p>The App offers several game modes, designed for kids:</p>
            <ul className="list-disc ml-5 mt-1">
              <li>
                The App may undergo periodic updates, and new features may be
                added. These updates may require changes to existing
                functionality or introduce new terms. You agree to accept any
                such updates when using the App.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">User Account</h1>
            <ul className="list-disc ml-5 mt-1">
              <h2 className="font-bold text-1xl">User registration</h2>
              <li>
                The App may undergo periodic updates, and new features may be
                added. These updates may require changes to existing
                functionality or introduce new terms. You agree to accept any
                such updates when using the App.
              </li>
              <h2 className="font-bold text-1xl pt-2">Account Security</h2>
              <li>
                You are responsible for maintaining the confidentiality of your
                account credentials, including the password. Any activity
                conducted under your account is your responsibility. If you
                suspect unauthorized access to your account, you must notify us
                immediately.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Privacy</h1>
            <p className="mt-1">
              Your use of the App is governed by our Privacy Policy, which
              explains how we collect, use, and protect personal information. We
              take extra care in collecting personal information from children,
              and we comply with applicable laws, such as COPPA.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Intellectual Property</h1>
            <ul className="list-disc ml-5 mt-1">
              <h2 className="font-bold text-1xl">Ownership</h2>
              <li>
                All content available through the App, including text, images,
                logos, graphics, software, and game assets, is owned by Recall
                Rush or its licensors and is protected by copyright, trademark,
                and other intellectual property laws.
              </li>
              <h2 className="font-bold text-1xl pt-2"> Trademarks</h2>
              <li>
                The trademarks, logos, and service marks displayed within the
                App are owned by Recall Rush or third parties. You are not
                permitted to use these marks without prior written consent.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Disclaimers</h1>
            <ul className="list-disc ml-5 mt-1">
              <h2 className="font-bold text-1xl">No Warranty</h2>
              <li>
                The App is provided on an "as is" and "as available" basis. We
                make no warranties, expressed or implied, regarding the
                functionality or availability of the App, including but not
                limited to warranties of merchantability or fitness for a
                particular purpose.
              </li>
              <h2 className="font-bold text-1xl pt-2">
                Limitation of Liability
              </h2>
              <li>
                We are not liable for any indirect, incidental, special, or
                consequential damages arising from your use or inability to use
                the App. This includes loss of data, profit, or business
                interruption, even if we have been advised of the possibility of
                such damages.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Indemnification</h1>
            <p className="mt-1">
              You agree to indemnify and hold harmless Recall Rush, its
              officers, employees, and affiliates, from any claims, losses,
              liabilities, or expenses (including legal fees) arising from your
              use of the App, violation of these Terms, or infringement of any
              third-party rights.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Termination</h1>
            <p className="mt-1">
              We may suspend or terminate your access to the App at our
              discretion, without prior notice or liability, if you violate
              these Terms, engage in activities that harm the App, other users,
              or violate laws. Upon termination, your right to use the App will
              cease immediately.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Governing Law</h1>
            <p className="mt-1">
              These Terms are governed by and construed in accordance with the
              laws. You agree to submit to the exclusive jurisdiction of the
              courts in this jurisdiction for any disputes arising under these
              Terms.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              Changes to Terms and Conditions
            </h1>
            <p className="mt-1">
              We reserve the right to modify these Terms at any time. Any
              changes will be posted on this page with an updated effective
              date. You are encouraged to review these Terms periodically. By
              continuing to use the App after changes are posted, you accept
              those changes.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">Contact Us</h1>
            <p className="mt-1">Email: info@thekaizenglobal.com</p>
          </div>
        </div>
      </div>
      <footer className="w-full mt-10 py-4 text-[#af61dd] bg-neutral-100 text-center">
        <h1>
          All Rights Reserved{" "}
          <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
        </h1>
      </footer>
    </div>
  );
}
